// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zjgh","name":"styles_name__2NyPd","phone":"styles_phone__2cwGS"};